import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionPointService } from '../../shared/services/index';
import { InspectionPoint } from '../../shared/models/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';

@Component({
    templateUrl: './notApplicable.component.html',
    standalone: false
})
export class MakePointNotApplicablePageComponent extends BaseModalPageComponent implements OnInit {
  errorMessage: string;
  public point: InspectionPoint;
  public notApplicableValues: any;
  public processing = false;
  editForm: UntypedFormGroup;

  inspectionId: string;
  pointId: string;
  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pointService: InspectionPointService,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      this.initData();
    });
  }

  initData(): void {
    this.notApplicableValues = _.orderBy(this.pointService.getNotApplicableValues(), ['label']);
    this.pointService.getPoint(this.inspectionId, this.pointId).subscribe((data) => {
      this.point = data;
      this.initForm();
    });
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      reason: new UntypedFormControl(this.point && this.point.reason ? +this.point.reason : -1, Validators.required),
      comment: new UntypedFormControl(this.point && this.point.comment ? this.point.comment : '', [])
    });
  }

  save(model: any): void {
    this.processing = true;
    this.pointService
      .setNotApplicable(this.inspectionId, this.point.id, model.reason, model.comment)
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
        this.goToBack();
      });
  }

  goToSection() {
    return this.router.navigate([this.inspectionsRoute, this.point.inspection.id, 'sections', this.point.section.id]);
  }

  cancel(): void {
    this.goToBack();
  }

  public openReasonsSelector(): void {
    this.openSelector(this.modal, this.notApplicableValues, this.editForm.controls['reason'].value);
  }

  public selectMenu(item: any) {
    const reasonControl = this.editForm.controls['reason'];
    const selectedIndex = reasonControl.value === item.selectedIndex ? -1 : item.selectedIndex;
    reasonControl.setValue(selectedIndex);

    const commentControl = this.editForm.controls['comment'];

    if (selectedIndex === 4) {
      commentControl.setValidators([Validators.required]);
    } else {
      commentControl.setValidators(null);
    }

    commentControl.markAsTouched();
    commentControl.updateValueAndValidity();
    this.cdf.detectChanges();
  }

  public isReasonValid() {
    return this.editForm.controls['reason'].value !== -1;
  }
}
